import React from 'react';
import { Link } from 'react-router-dom';
import './PartnerWithUs.css';

const PartnerWithUs = () => {
  return (
    <div style={{ 
      padding: '3rem 2rem', 
      maxWidth: '1200px', 
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif'
    }}>
      {/* Page Title */}
      <h1 style={{
        fontSize: '2.5rem',
        fontWeight: 'bold',
        color: '#2c5aa0',
        textAlign: 'center',
        marginBottom: '2rem'
      }}>
        Partner With Datafre8
      </h1>

      {/* Introductory Text */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '2.5rem',
        borderRadius: '16px',
        marginBottom: '3rem',
        border: '1px solid #e9ecef',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        textAlign: 'center'
      }}>
        <h2 style={{
          fontSize: '1.8rem',
          fontWeight: 'bold',
          color: '#2c5aa0',
          margin: 0
        }}>
          Unlock the Power of 3D Computer Vision for Your Team.
        </h2>
      </div>

      {/* Main Content */}
      <div style={{
        backgroundColor: '#ffffff',
        padding: '2.5rem',
        borderRadius: '16px',
        border: '1px solid #e9ecef',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        
        {/* Section 1: What is 3D Machine Learning */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h3 style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1.5rem'
          }}>
            But what exactly is 3D machine learning?
          </h3>
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.7',
            color: '#333',
            margin: 0
          }}>
            DataFre8 is designed to empower researchers and developers across industries to tap into the full potential of 3D computer vision—without the usual complexity. Whether you're working in surveying, building information modeling (BIM), robotics, autonomous systems, healthcare, or any field where 3D data is essential, DataFre8 delivers a powerful, low-code platform designed to meet your specific needs.
          </p>
        </div>

        {/* Section 2: Partnership Information */}
        <div style={{ marginBottom: '2.5rem' }}>
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.7',
            color: '#333',
            margin: 0
          }}>
            Organizations, startups, research institutions, and innovators are invited to connect with DataFre8 to explore potential use cases, collaborations, or strategic partnerships. Tailored online consulting sessions are available to better understand your specific challenges and objectives. Based on your needs, DataFre8 delivers customized solutions powered by its comprehensive suite of tools—from data preprocessing and annotation to model training, deployment, and visualization.
          </p>
        </div>

        {/* Section 3: Call to Action */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '2rem',
          borderRadius: '12px',
          border: '1px solid #e9ecef',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.7',
            color: '#333',
            margin: 0
          }}>
            Get in touch today via our{' '}
            <Link 
              to="/contact-us" 
              style={{
                color: '#2c5aa0',
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = 'none';
              }}
            >
              contact form
            </Link>
            {' '}or email us at{' '}
            <a 
              href="mailto:team@datafre8.com"
              style={{
                color: '#2c5aa0',
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = 'none';
              }}
            >
              team@datafre8.com
            </a>
            {' '}to schedule a consultation and explore how we can bring your 3D vision projects to life.
          </p>
        </div>

      </div>
    </div>
  );
};

export default PartnerWithUs; 